module.exports = __webpack_public_path__ + "img/expression.41340516.png";